// Purpose: Shared logic to choose which project the Header should display based on pathname

export function getHeaderProject(projects, pathname) {
  if (!Array.isArray(projects) || projects.length === 0) return null;

  // Content routes that should use 'about' project theme (kept for completeness)
  const contentRoutes = ['/about', '/about/cv', '/terms', '/privacy', '/shipping', '/imprint'];
  if (contentRoutes.includes(pathname)) {
    return projects.find(p => p.id === 'about') || null;
  }

  // Collection route like /jnn-drc → match by id
  const match = pathname.match(/^\/[a-zA-Z-]+$/);
  if (match) {
    const projectId = pathname.slice(1);
    const byId = projects.find(p => p.id === projectId);
    if (byId) return byId;
  }

  return null;
}

